import { render } from "./DotElement.vue?vue&type=template&id=1dacd36f&scoped=true"
import script from "./DotElement.vue?vue&type=script&lang=js"
export * from "./DotElement.vue?vue&type=script&lang=js"

import "./DotElement.vue?vue&type=style&index=0&id=1dacd36f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dacd36f"]])

export default __exports__